var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepeatedLottery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 149,
    viewBox: "0 0 257 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1020_2140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.833 45.3333C169.833 40.8293 166.169 37.1665 161.667 37.1665H149.417V31.0415C149.417 29.9132 148.504 29 147.375 29C146.246 29 145.333 29.9132 145.333 31.0417V37.1667H108.583V31.0417C108.583 29.9132 107.67 29 106.542 29C105.413 29 104.5 29.9132 104.5 31.0417V37.1667H88.1667C83.6647 37.1667 80 40.8293 80 45.3333V110.667C80 115.171 83.6647 118.833 88.1667 118.833H147.371V118.832L147.375 118.833C147.906 118.833 148.428 118.626 148.819 118.235L169.236 97.8184C169.625 97.4275 169.754 96.906 169.754 96.3748H169.834V45.3333H169.833Z",
    fill: "#303C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.167 41.25H104.5V45.3333C102.247 45.3333 100.417 47.1656 100.417 49.4165C100.417 51.6675 102.247 53.5 104.5 53.5C106.753 53.5 108.583 51.6677 108.583 49.4167V41.25H145.333V45.3333C143.08 45.3333 141.25 47.1656 141.25 49.4165C141.25 51.6675 143.081 53.5 145.333 53.5C147.586 53.5 149.417 51.6677 149.417 49.4167V41.25H161.667C163.92 41.25 165.75 43.0823 165.75 45.3333V57.5833H84.0835V45.3333C84.0835 43.0823 85.9139 41.25 88.167 41.25Z",
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M145.333 41.25H108.583V43.2917H145.333V41.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.1668 43.2917H104.5V41.25H88.1668C85.9137 41.25 84.0835 43.0823 84.0835 45.3333V47.375C84.0833 45.1241 85.9137 43.2917 88.1668 43.2917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.667 41.25H149.417V43.2917H161.667C163.92 43.2917 165.75 45.1241 165.75 47.375V45.3333C165.75 43.0823 163.92 41.25 161.667 41.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.333 102.5V114.75H88.1668C85.9137 114.75 84.0835 112.918 84.0835 110.667V61.6667H165.75V94.3335H153.5C148.998 94.3333 145.333 97.996 145.333 102.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.417 111.863V102.5C149.417 100.249 151.247 98.4167 153.5 98.4167H162.863L149.417 111.863Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.333 114.75V102.5C145.333 97.996 148.998 94.3333 153.5 94.3333H165.75V61.6667H84.0835L137.167 114.75H145.333Z",
    fill: "url(#paint0_linear_1020_2140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75 73.9167C112.248 73.9167 108.583 77.5793 108.583 82.0835C108.583 83.212 109.497 84.1252 110.625 84.1252C111.754 84.1252 112.667 83.212 112.667 82.0835C112.667 79.8325 114.497 78.0002 116.75 78.0002C119.003 78.0002 120.833 79.8325 120.833 82.0835C120.833 84.3344 119.003 86.1667 116.75 86.1667C115.622 86.1667 114.708 87.0799 114.708 88.2085C114.708 89.337 115.622 90.25 116.75 90.25C119.003 90.25 120.833 92.0823 120.833 94.3333C120.833 96.5842 119.003 98.4165 116.75 98.4165C114.497 98.4165 112.667 96.5842 112.667 94.3333C112.667 93.2047 111.754 92.2915 110.625 92.2915C109.497 92.2915 108.583 93.2047 108.583 94.3333C108.583 98.8374 112.248 102.5 116.75 102.5C121.252 102.5 124.917 98.8374 124.917 94.3333C124.917 91.8969 123.844 89.7056 122.146 88.2083C123.844 86.7109 124.917 84.5197 124.917 82.0833C124.917 77.5793 121.252 73.9167 116.75 73.9167Z",
    fill: "#303C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.125 73.9167C135.125 73.9167 135.125 73.9167 135.121 73.9167L131.046 73.9208C129.917 73.9227 129.004 74.8359 129.004 75.9644C129.004 77.0908 129.917 78.004 131.046 78.004C131.046 78.004 131.046 78.004 131.05 78.004L133.083 78.0021V100.458C133.083 101.587 133.997 102.5 135.125 102.5C136.254 102.5 137.167 101.587 137.167 100.458V75.9585C137.167 75.4162 136.951 74.8977 136.569 74.5149C136.186 74.1321 135.667 73.9167 135.125 73.9167Z",
    fill: "#303C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.542 127C167.945 127 178 116.945 178 104.542C178 92.1384 167.945 82.0835 155.542 82.0835C143.138 82.0835 133.083 92.1384 133.083 104.542C133.083 116.945 143.138 127 155.542 127Z",
    fill: "#303C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.542 122.917C165.69 122.917 173.917 114.69 173.917 104.542C173.917 94.3935 165.69 86.1667 155.542 86.1667C145.393 86.1667 137.167 94.3935 137.167 104.542C137.167 114.69 145.393 122.917 155.542 122.917Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.549 102.157C151.486 101.531 151.741 100.265 151.115 99.3257C150.481 98.3805 149.213 98.1354 148.284 98.7595L146.39 100.024C148.057 96.6541 151.534 94.3333 155.542 94.3333C158.939 94.3333 162.101 96.0161 164.007 98.8353C164.641 99.7704 165.909 100.014 166.843 99.3837C167.776 98.7536 168.023 97.4836 167.389 96.5505C164.725 92.6047 160.295 90.25 155.542 90.25C147.662 90.25 141.25 96.6621 141.25 104.542C141.25 105.295 141.665 105.987 142.327 106.342C142.63 106.504 142.961 106.583 143.292 106.583C143.687 106.583 144.081 106.468 144.424 106.24L150.549 102.157Z",
    fill: "#303C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.757 102.741C168.095 102.388 167.289 102.424 166.659 102.843L160.534 106.926C159.597 107.552 159.342 108.818 159.968 109.757C160.594 110.696 161.862 110.94 162.799 110.324L164.694 109.059C163.027 112.429 159.549 114.75 155.542 114.75C152.144 114.75 148.982 113.067 147.076 110.248C146.446 109.311 145.17 109.072 144.241 109.7C143.308 110.33 143.061 111.6 143.695 112.533C146.358 116.479 150.789 118.833 155.542 118.833C163.422 118.833 169.834 112.421 169.834 104.542C169.833 103.788 169.419 103.096 168.757 102.741Z",
    fill: "#303C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.833 87.2311V45.3333C169.833 40.8293 166.169 37.1665 161.667 37.1665H149.417V31.0415C149.417 29.9132 148.504 29 147.375 29C146.246 29 145.333 29.9132 145.333 31.0417V37.1667H108.583V31.0417C108.583 29.9132 107.67 29 106.542 29C105.413 29 104.5 29.9132 104.5 31.0417V37.1667H88.1667C83.6647 37.1667 80 40.8293 80 45.3333V110.667C80 115.171 83.6647 118.833 88.1667 118.833H138.231C142.354 123.818 148.583 127 155.542 127C167.925 127 178 116.925 178 104.542C178 97.5828 174.818 91.3538 169.833 87.2311Z",
    fill: "url(#paint1_linear_1020_2140)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1020_2140",
    x1: 104.501,
    y1: 41.2541,
    x2: 161.667,
    y2: 98.4206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1020_2140",
    x1: 74.9845,
    y1: 54.2844,
    x2: 180.758,
    y2: 103.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1020_2140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white",
    transform: "translate(80 29)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatedLottery);
export default __webpack_public_path__ + "static/media/repeatedLottery.37c7e66cb12933a7a5e33a24cdbf5e01.svg";
export { ForwardRef as ReactComponent };